<div *ngIf="!!hasAirPolicies" class="policiesDetail__cont">
  <div class="policiesDetail__header">
    <app-ds-typography
      [tag]="'h2'"
      [fontFamily]="fontFamily.SemiBold"
      [color]="fontColor.Primary"
      [size]="isUserHistory ? fontSize.RG : fontSize.XS"
      [text]="'BOOKING_MODULE.CANCELLATION_POLICIES' | transloco">
    </app-ds-typography>
    <div class="policiesDetail__header-description" [class.is-user-history]="isUserHistory">
      <app-ds-typography
        [text]="'BOOKING_MODULE.CHANGE_CANCEL_POLICIES.HEADER' | transloco"
        [fontFamily]="fontFamily.Regular"
        [color]="fontColor.Secondary"
        [size]="fontSize.XXS"
        [tag]="'h3'">
      </app-ds-typography>
    </div>
  </div>
  <app-air-terms *ngFor="let validation of airValidation; trackBy: trackById; first as isFirst; last as isLastItem"
    [airValidation]="validation"
    [isMobile]="isMobile"
    [isLastItem]="isLastItem"
    [showFreeCancellation]="showCancellationBanner(isFirst)">
  </app-air-terms>
</div>
